import { useState, useContext, useEffect } from 'react';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { GeneralContext } from '../../../context/generalContext';
import classes from '../MenuCardModal/MenuCardModal.module.scss';
import closeIcon from '../../../images/icon-close.png';
import MenuCardMobile from '../MenuCardMobile/MenuCardMobile';

export default function MenuCardModalEnglish({ modalActive, setModalActive, item, choices }) {
  const { windowWidth, activeCity } = useContext(GeneralContext);
  const [activeType, setActiveType] = useState('');
  useEffect(() => {
    setActiveType(choices[0]?.name_en);
  }, [choices]);

  const changeType = type => {
    setActiveType(type);
  };

  const [modalPhotoActive, setModalPhotoActive] = useState(false);

  // заморозить область за модальным если оно открыто
  useEffect(() => {
    if (modalActive) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }
  }, [modalActive]);

  const filteredItem = item.info.filter(infoItem => infoItem.type_en === activeType || infoItem.type === activeType)[0];

  return (
    <div
      className={`${classes.cardModal} ${modalActive ? `${classes.cardModalActive}` : ''}`}
      onClick={() => setModalActive(false)}
    >
      <div className={classes.cardModalContent} onClick={e => e.stopPropagation()}>
        {windowWidth > 767 ? (
          <>
            <img
              className={classes.cardModalCloseBtn}
              src={closeIcon}
              alt='close icon'
              onClick={() => setModalActive(false)}
            />
            <div className={classes.cardModalTitle}>{item.name_en || item.name}</div>
            <p
              className={classes.cardModalText}
              dangerouslySetInnerHTML={{
                __html: item.info[0]?.text_en || item.description_en || item.info[0]?.text || item.description_ru,
              }}
            />

            <div className={classes.cardModalImgCalories}>
              {choices.length >= 2 && choices[0]?.name.length >= 2 ? (
                <>
                  {filteredItem?.img && (
                    <LazyLoadComponent>
                      <div className={classes.cardModalImg} style={{ backgroundImage: `url(${filteredItem.img})` }} />
                    </LazyLoadComponent>
                  )}
                </>
              ) : (
                <>
                  {item.img && (
                    <LazyLoadComponent>
                      <div className={classes.cardModalImg} style={{ backgroundImage: `url(${item.img})` }} />
                    </LazyLoadComponent>
                  )}
                </>
              )}
              <div className={classes.cardModalCaloriesInfo}>
                {choices.length >= 2 && choices[0]?.name_en.length >= 2 ? (
                  <div>
                    {choices.map((choice, index) => (
                      <button
                        className={`${classes.cardModalType} ${
                          activeType === item.info.filter(el => el.type_en === choice.name_en)[0]?.type_en
                            ? `${classes.cardModalTypeActive}`
                            : ''
                        }`}
                        onClick={() => changeType(item.info.filter(el => el.type_en === choice.name_en)[0]?.type_en)}
                        key={index}
                      >
                        {item.info.filter(el => el.type_en === choice.name_en)[0]?.type_en}
                      </button>
                    ))}
                    <div className={classes.cardModalPriceWeight}>
                      {activeCity !== 0 && (
                        <p
                          className={classes.cardModalPrice}
                          dangerouslySetInnerHTML={{
                            __html: `${choices.filter(choice => choice.name_en === activeType)[0]?.price}&nbsp;${
                              activeCity === 6 ? 'uzs' : '&#8381;'
                            }`,
                          }}
                        />
                      )}
                      {filteredItem?.weight && <p>{filteredItem?.weight} g</p>}
                    </div>
                    {filteredItem?.calories && (
                      <p className={classes.cardModalTextInfo}>
                        CPFC {filteredItem?.calories}
                        &nbsp;<span className={classes.cardModalSlash}>/</span> {filteredItem?.proteins}
                        &nbsp;<span className={classes.cardModalSlash}>/</span> {filteredItem?.fats}
                        &nbsp;<span className={classes.cardModalSlash}>/</span> {filteredItem?.carbohydrates}
                      </p>
                    )}
                  </div>
                ) : (
                  <div>
                    <div className={classes.cardModalPriceWeight}>
                      {activeCity !== 0 && (
                        <p
                          className={classes.cardModalPrice}
                          dangerouslySetInnerHTML={{
                            __html: `${choices[0]?.price}&nbsp;${activeCity === 6 ? 'uzs' : '&#8381;'}`,
                          }}
                        />
                      )}
                      {item.info[0]?.weight && <p>{item.info[0]?.weight}g</p>}
                    </div>
                    {item.info[0]?.calories && (
                      <p className={classes.cardModalTextInfo}>
                        CPFC {item.info[0]?.calories}
                        &nbsp;<span className={classes.cardModalSlash}>/</span> {item.info[0]?.proteins}
                        &nbsp;<span className={classes.cardModalSlash}>/</span> {item.info[0]?.fats}
                        &nbsp;<span className={classes.cardModalSlash}>/</span> {item.info[0]?.carbohydrates}
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
          <MenuCardMobile
            isOpen={modalActive}
            setIsOpen={setModalActive}
            item={item}
            choices={choices}
            filteredItem={filteredItem}
            activeType={activeType}
            changeType={changeType}
            setModalPhotoActive={setModalPhotoActive}
            modalPhotoActive={modalPhotoActive}
          />
        )}
      </div>
    </div>
  );
}
